module.exports = __webpack_public_path__ + "img/imToken.97de1461.svg";